export default __webpack_public_path__ + "static/media/importGeneric.f44e1a6c.svg";